// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Hb6K","errors":"Errors_errors__1vz_n"};